import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Agenda from "./pages/Agenda";
import Sessions from "./pages/Sessions";
import Group from "./pages/Group";
import GroupDetail from "./pages/GroupDetail";
import More from "./pages/More";
import Locations from "./pages/Locations";
import Resources from "./pages/Resources";
import Links from "./pages/Links";
import Feedback from "./pages/Feedback";
import Admin from "./pages/Admin";
import SuccessStartsHere from "./pages/SuccessStartsHere";
import Keynote from "./pages/Keynote";
import Sponsors from "./pages/Sponsors";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/group" element={<Group />} />
            <Route path="/group/:id" element={<GroupDetail />} />
            <Route path="/more" element={<More />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/links" element={<Links />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/success-starts-here" element={<SuccessStartsHere />} />
            <Route path="/keynote" element={<Keynote />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
